// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__kK_lO","title":"ClientReferral_title__1sbdj","itemText":"ClientReferral_itemText__2iJNc"};